export default __webpack_public_path__ + "ali@2x.33a52d01.png";